module.exports = __webpack_public_path__ + "static/media/carbon.df0363d5.png";